import { MenuItemProps, MenuItem, useTheme } from "@mui/material";

const BaseSelectItem = (props: MenuItemProps) => {
  const theme = useTheme();
  return (
    <MenuItem sx={{ display: "flex", alignItems: "center", gap: theme.spacing(1) }} {...props}>
      {props.children}
    </MenuItem>
  );
};

export default BaseSelectItem;
